import { render, staticRenderFns } from "./DefectiveProductKucun.vue?vue&type=template&id=4b8de0c7&scoped=true&"
import script from "./DefectiveProductKucun.vue?vue&type=script&lang=js&"
export * from "./DefectiveProductKucun.vue?vue&type=script&lang=js&"
import style0 from "./DefectiveProductKucun.vue?vue&type=style&index=0&id=4b8de0c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8de0c7",
  null
  
)

export default component.exports